import React, { Component } from 'react'
import AdminDashboard from './adminDashboard'

class AdminPayment extends Component {
    constructor(props) {
        super(props)

        this.state = {
                 
        }
    }

    render() {
        return (
            <AdminDashboard>
                <h1>Payment Page</h1>
            </AdminDashboard>
        )
    }
}

export default AdminPayment
